//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MiniNavBar from '@/components/MiniNavBar.vue';
import CustomSwiper from '@/components/CustomSwiper.vue';
import VideoWrapper from '@/components/VideoWrapper.vue';
import ScrollTop from '@/components/ScrollTop.vue';
export default {
    components: { MiniNavBar, CustomSwiper, VideoWrapper, ScrollTop },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.getViewIntro();
            vm.getVr();
            vm.getCulture();
        });
    },
    data() {
        return {
            swiperList: [],
            videoUrl:
                'https://sunlue.oss-cn-chengdu.aliyuncs.com/video/%E6%B4%AA%E5%AE%89%E8%BE%B9%E5%9F%8E.mp4',
            viewIntro: '',
            vrData: '',
            cultureList: [],
            guideList: null
        };
    },
    mounted() {
        new window.Swiper('.swiper', {
            // 循环模式选项
            loop: false,
            /* autoplay: {
                disableOnInteraction: false
            }, */
            effect: 'coverflow',
            slidesPerView: 'auto',
            centeredSlides: false,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 0,
                modifier: 0,
                slideShadows: false
            }
            // 如果需要前进后退按钮
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev'
            // }
        });
        this.getGuideList();
    },
    methods: {
        getViewIntro() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '7'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.viewIntro = res.data;
                }
            });
        },
        getVr() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: 60
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.vrData = res.data;
                }
            });
        },
        getCulture() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 6
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.cultureList = res.data;
                }
            });
        },
        toVrPage() {
            var url = this.vrData.outUrl;
            if (url) {
                url = encodeURIComponent(url);
                this.$router.push('./vr?src=' + url);
            }
        },
        tryToPlay() {
            const url = encodeURIComponent(this.videoUrl);
            this.$router.push('./video-player?src=' + url);
        },
        getGuideList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '8',
                    pageNum: 1,
                    pageSize: 10,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.guideList = res.data.data;
                }
            });
        }
    }
};
